export var ACCEPT_LANGUAGE = 'accept-language';
export var AUTHORIZATION = 'authorization';
export var CLIENT_APPLICATION = 'x-client-application';
export var CONTENT_TYPE = 'content-type';
export var CUSTOMER_CONTEXT = 'x-customer-context';
export var TENANT_CONTEXT = 'x-tenant-context';
//# sourceMappingURL=headers.js.map